
import {Component, Vue} from 'vue-property-decorator';
import Pagination from "@/components/Pagination/index.vue";
import {ElForm} from "element-ui/types/form";
import {bindNeiXiao, getReceiptAllocateRecord} from "@/api/invoice/index";
import {Decimal} from "decimal.js";
import InvoiceReceiptChooser from "@/views/invoice/component/InvoiceReceiptChooser.vue";

@Component({
  name: 'BindNeiXiaoInvoice',
  components: {InvoiceReceiptChooser, Pagination}
})
export default class BindNeiXiaoInvoice extends Vue {

  private showDialog = false;
  private loading = false;
  private options = {
    title: "",
    id: "",
    factoryId: null,
    factoryName: null,
    amount: 0,
    company: null
  }
  //单据号码	客人简称	报关品名	单据金额	已登记金额	本次登记金额
  private tableCol = [
    {
      label: "单据号码",
      prop: "receiptCode",
      key: "receiptCode",
    },
    {
      label: "客人简称",
      prop: "customerAbbr",
      key: "customerAbbr",
      render: (prop, row) => {
        return row.extMap?.customerAbbr
      }
    },
    {
      label: "报关品名",
      prop: "productName",
      key: "productName",
      render: (prop, row) => {
        return row.extMap?.productName
      }
    },
    {
      label: "单据金额",
      prop: "amount",
      key: "amount",
    },
    {
      label: "已登记金额",
      prop: "totalAllocateAmount",
      key: "totalAllocateAmount",
    },
    {
      label: "本次分配金额",
      prop: "allocateAmount",
      key: "allocateAmount",
      type: "inputNumber",
      maxProp: "maxProp",
      width: 120,
      precision: 4,
      check: {
        prefix: "list",
        rules: [
          {
            required: true,
            message: '请输入本次分配金额',
            trigger: 'blur'
          },
          // 不能小于等于0
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(new Error('不能小于等于0'));
              } else {
                callback();
              }
            }
          }
        ]
      }
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "移除",
          type: "delete",
          code: "",
          click: "handleRemove",
        },
        // {
        //   name: "修改金额",
        //   code: "",
        //   click: "handleUpdate",
        // }
      ],
      width: 120,
    },
  ]
  private table = {
    list: [] as any[],
  };

  private selectLoading = false;

  private async getList() {
    getReceiptAllocateRecord({id: this.options.id})
        .then(({data}) => {
          this.table.list = (data as any[]).map(item => {
            item.maxProp = new Decimal(item.amount).add(new Decimal(item.allocateAmount))
                .sub(new Decimal(item.totalAllocateAmount)).toNumber();
            return item;
          })
          this.loading = false;
        })
  }

  public handleAddInvoice() {
    (this.$refs['invoiceReceiptChooserRef'] as InvoiceReceiptChooser)
        .openDialog({
          id: this.options.id,
          factoryId: this.options.factoryId,
          factoryName: this.options.factoryName,
          company: this.options.company,
          selectedReceipt: this.table.list
        }, {title: "选择单据"})
  }

  public handleConfirmChooser(selected) {
    selected.forEach(item => {
      let totalAllocateAmount = new Decimal(0);
      this.table.list.forEach(i => {
        totalAllocateAmount = totalAllocateAmount.add(new Decimal(i.allocateAmount))
      })
      item.allocateAmount = Math.min(item.allocateAmount, new Decimal(this.options.amount).sub(totalAllocateAmount).toNumber())
      this.table.list.push(item);
    })
  }

  public handleRemove({row}) {
    this.table.list = this.table.list.filter(item => item.id !== row.id)
  }

  private confirmLoading = false;

  public handleSubmit() {
    this.confirmLoading = true;
    (this.$refs.form as ElForm).validate(async (valid) => {
      try {
        if (valid) {
          await bindNeiXiao({
            invoiceId: this.options.id,
            allocateReceipts: this.table.list,
          });
          this.showDialog = false;
          this.$emit("confirm")
        }
      } finally {
        this.confirmLoading = false
      }
    });
  }


  public async openDialog(obj, options) {
    this.options = options;
    this.options.id = obj.id;
    this.options.factoryId = obj.factoryId;
    this.options.factoryName = obj.factoryName;
    this.options.amount = obj.amount;
    this.options.company = obj.company;
    this.showDialog = true;
    this.getList()
  }

}
